import React from 'react';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { changeEventFilter } from '../../../../../store/actions/sportEvents';
import { LANGUAGES } from '../../../../../constants/defaultValues';
import { getTranslation } from '../../../../../utils/translation';
import { EVENT_FILTER_OPTIONS } from '../../../../../constants/event-filters';
import styles from '../Categories/Categories.module.scss';
import classNames from 'classnames';

const Leagues = props => {
    const dispatch = useDispatch();

    const locale = useSelector(state => state.settings.locale);
    const categories = useSelector(state => state.sportEvents.filters.categories) || [];
    const leagues = useSelector(state => state.sportEvents.filters.leagues) || [];

    const selectedCategoryId = categories.find(category => category.selected)?.id;

    const options = leagues
        .filter(
            league =>
                !selectedCategoryId ||
                !league.categoryId ||
                selectedCategoryId === EVENT_FILTER_OPTIONS.categories.all.id ||
                league.categoryId === selectedCategoryId
        )
        .map(league => {
            const { names, category, countryCode, categoryName: countryName } = league;

            const categoryName =
                countryName ||
                (category ? category.names[locale] || category.names[LANGUAGES.eng] : null);
            const label = `${categoryName ? categoryName + ', ' : ''}${
                league.label || names[locale] || names[LANGUAGES.eng]
            }`;

            return {
                value: league.id,
                label: (
                    <div className={styles.options}>
                        {countryCode && (
                            <div className={classNames(styles.flagContainer)}>
                                <img
                                    alt={countryCode}
                                    src={`/assets/flags/${
                                        countryCode?.trim() ? countryCode.toLowerCase() : 'int'
                                    }.svg`}
                                    className={styles.flag}
                                />
                            </div>
                        )}

                        <div>{label}</div>
                    </div>
                ),
                selected: league.selected,
                categoryId: league.categoryId,
            };
        });

    const selectedOption = options.find(option => option.selected);

    const onChange = value => {
        if (value.value === selectedOption.value) return;

        if (props.onChange) {
            props.onChange(value);
        }

        const newLeagues = leagues.map(league => ({
            ...league,
            selected: league.id === value.value,
        }));

        dispatch(changeEventFilter({ key: 'leagues', value: newLeagues }));
    };

    return (
        <Select
            className='common-select common-select--events'
            classNamePrefix='common'
            menuPlacement={'auto'}
            value={selectedOption}
            onChange={onChange}
            options={options}
            noOptionsMessage={getTranslation('noOptionsMessage')}
        />
    );
};

export default Leagues;
